module.exports = __webpack_public_path__ + "img/Objets_decoratifs.a44b014.jpg";